export default function apply_favicon() {
  const favIcon = document.createElement('link');

  favIcon.rel = 'icon';
  favIcon.href = '/img/favicon2025.svg';
  document.getElementsByTagName('head')[0].appendChild(favIcon);
}
